// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__1iySI","banner__image":"styles_banner__image__1vyEX"};